module.exports = __webpack_public_path__ + "assets/img/Tune_rousset.dc5657db-ps.jpg";